import { useState } from "react";
import { Table, Dropdown, Checkbox, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const fakeData = Array.from({ length: 12 }).map((_, i) => ({
    key: i,
    time: `0${i + 1}/03/2026`,
    newCustomer: Math.floor(Math.random() * 5),
    phoneToday: Math.floor(Math.random() * 10),
    phoneNew: Math.floor(Math.random() * 5),
    commentCus: Math.floor(Math.random() * 5),
    messageCus: Math.floor(Math.random() * 5),
    commentPage: Math.floor(Math.random() * 5),
    messagePage: Math.floor(Math.random() * 5),
    order: Math.floor(Math.random() * 10)
}));

export default function DetailedReportTable() {
    const { t } = useTranslation();

    const allColumns = [
        { title: t('page_report.col_time'), dataIndex: "time", key: "time" },
        { title: t('page_report.col_new_customer'), dataIndex: "newCustomer", key: "newCustomer" },
        { title: t('page_report.col_phone_today'), dataIndex: "phoneToday", key: "phoneToday" },
        { title: t('page_report.col_phone_new'), dataIndex: "phoneNew", key: "phoneNew" },
        { title: t('page_report.col_comment_customer'), dataIndex: "commentCus", key: "commentCus" },
        { title: t('page_report.col_message_customer'), dataIndex: "messageCus", key: "messageCus" },
        { title: t('page_report.col_comment_page'), dataIndex: "commentPage", key: "commentPage" },
        { title: t('page_report.col_message_page'), dataIndex: "messagePage", key: "messagePage" },
        { title: t('page_report.col_orders'), dataIndex: "order", key: "order" }
    ];

    const [visibleColumns, setVisibleColumns] = useState(
        allColumns.map(c => c.key)
    );

    const toggleColumn = (key: string) => {
        setVisibleColumns(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    };

    const selectAll = () => {
        setVisibleColumns(allColumns.map(c => c.key));
    };

    const deselectAll = () => {
        setVisibleColumns([]);
    };

    const columns = allColumns.filter(col =>
        visibleColumns.includes(col.key)
    );

    const menu = (
        <div className="choose-column-menu">

            <div className="flex gap-2 mb-3">
                <Button size="small" onClick={selectAll}>{t('page_report.select_all')}</Button>
                <Button size="small" onClick={deselectAll}>{t('page_report.deselect_all')}</Button>
            </div>

            {allColumns.map(col => (
                <div key={col.key} className="mb-2">
                    <Checkbox
                        checked={visibleColumns.includes(col.key)}
                        onChange={() => toggleColumn(col.key)}
                    >
                        {col.title}
                    </Checkbox>
                </div>
            ))}

        </div>
    );

    return (
        <div className="bg-white dark:bg-[#1f1f1f] rounded-xl p-5">

            {/* header */}

            <div className="flex justify-between mb-4">

                <h3 className="font-semibold text-gray-800 dark:text-gray-200">
                    {t('page_report.detailed_report')}
                </h3>

                <div className="flex gap-3">

                    <Dropdown trigger={["click"]} dropdownRender={() => menu}>
                        <Button>{t('page_report.select_columns')}</Button>
                    </Dropdown>

                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                    >
                        {t('page_report.export_excel')}
                    </Button>

                </div>

            </div>

            <Table
                columns={columns}
                dataSource={fakeData}
                pagination={false}
                scroll={{ x: "max-content" }}
                className="custom-ant-table"
            />

        </div>
    );
}